import React from 'react';
import './adresslist.scss';
import Parser from 'html-react-parser';
import { umoksType } from '../../types/types.js';
import { adressCard } from './adresscard/adresscard.jsx';


class AdressList extends React.Component {
  constructor(props) {
    super(props);
  };

    getTitle = () => {
      const { contactList } = this.props;

      return (contactList && <h2> {contactList.title} </h2>);
    };

    getAdressList = () => {
      // if (this.props.contactList !== null)
      const { contactList } = this.props;

      return contactList && contactList.content.map((item, i, arr) => {
        const content = () => {
          return item.content.map((item, i, arr) => {
            return (
              <div key={'advert-id-' + i} className='f-item f-item-6 f-center'>
                {adressCard({ items:item })}
              </div>
            );
          });
        };

        return (
          <div key={'advert-id-' + i} className='f-item f-item-12 f-center'>
            <div className='f-container'>
              <h3>{Parser(item.title)}</h3>
              <div className='f-row border-bottom'>
                {content()}
              </div>
            </div>
          </div>
        );
      });
    };

    render() {
      return (
        <section className='adresslist-wrap f-center'>
          <div className='f-container'>
            {this.getTitle()}
            <div className='f-row'>
              {this.getAdressList()}
            </div>
          </div>
        </section>
      );
    };
};

AdressList.propTypes = {
  advertList:umoksType.isRequired
};

export default AdressList;



// WEBPACK FOOTER //
// ./src/client/components/adresslist/adresslist.jsx